// extracted by mini-css-extract-plugin
export default {"row":"Grid_row__WpiOi","stretch":"Grid_stretch__ffrIG"};